import React from 'react';

const ClientCard = ({ client, location, imgSrc, ...prop }) => {
  return (
    <div
      {...prop}
      className="card w-80 md:w-56 lg:w-80  mt-5 hover:scale-110 duration-300"
    >
      <img src={imgSrc} alt={imgSrc} />
      <div className="m-4">
        <span className="font-bold">{client}</span>
        <span className="block text-gray-500 text-sm">{location}</span>
      </div>
    </div>
  );
};

export default ClientCard;
